import {
  AgentsMonthReport, ChipsCounters,
  DealsListingSearch, OffersManagementListingItem, OfficeMonthReport, ReasonOfUnpublish, RoleId,
} from 'common/types';
import {apiMethod, APIService} from 'services/APIService';
import {FetchStreetsPayload} from '../GeoAPI';

interface FetchUnpublishReasonsPayload {
  roleId: RoleId;
}

export interface SmallDealsListing {
  items: OffersManagementListingItem[];
}

export class DealsAPI extends APIService {
  fetchDealsList = apiMethod((params: Partial<DealsListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/list/',
      params,
    }),
  );
  fetchGeoDeals = apiMethod((params: Partial<DealsListingSearch>) =>
      this.fetcher.request({
        method: 'get',
        url: '/api/deals/map/',
        params
      }),
  );

  fetchFilterBbox = apiMethod((params: Partial<DealsListingSearch>) =>
      this.fetcher.request({
        method: 'get',
        url: '/api/deals/filter-bbox/',
        params
      }),
  );
  getDealsInfo = apiMethod((id: number[], params: Partial<DealsListingSearch>) =>
      this.fetcher.request({
        method: 'post',
        url: '/api/deals/deals-by-id/',
        data: {
          ids: id,
          ...params
        }
      }),
  );
  fetchPrices = apiMethod((params: Partial<DealsListingSearch>) =>
      this.fetcher.request({
        method: 'get',
        url: '/api/deals/prices-box/',
        params
      }),
  );
  monthReport = apiMethod<AgentsMonthReport>((params: Partial<DealsListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/month-report/',
      params
    }),
  );
  officeReport = apiMethod<OfficeMonthReport>((params: Partial<DealsListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/office-report/',
      params
    }),
  );
  exportDealsList = (params: Partial<DealsListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/export-csv/',
      params,
    });
  smallDealsFetcher = apiMethod<SmallDealsListing>(() =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/small-list/',
    }),
  );
  dealsReasonsOfUnpublishFetcher = apiMethod<ReasonOfUnpublish[]>((payload: FetchUnpublishReasonsPayload) =>
    this.fetcher.request({
      url: '/api/common/permission-reasons/',
      params: {
        groupId: payload.roleId,
        forDeals: true
      },
    }),
  );
  changeReason = apiMethod(
    (offersIds: number[], reason?: number | string) =>
      this.fetcher.request({
        method: 'get',
        url: '/api/deals/change-reason/',
        params: {
          id: offersIds.join(','),
          reason,
        },
      })
  );
  removeDeal = apiMethod(
    (id: number) =>
      this.fetcher.request({
        method: 'delete',
        url: `/api/deals/${id}/`,
      })
  );
  getChipsCounters = apiMethod<ChipsCounters>((params: Partial<DealsListingSearch>) =>
    this.fetcher.request({
      method: 'get',
      url: '/api/deals/chips-counters/',
      params,
    })
  );

  searchQuery = apiMethod((params: FetchStreetsPayload) => {
    return this.fetcher.request({
      method: 'get',
      url: '/api/deals/search/',
      params,
    });
  });

  changeDealVerificationNumber = apiMethod((dealId: number, number: string) =>
    this.fetcher.request({
      method: 'post',
      url: '/api/deals/change-verification-number/',
      data: {
        id: dealId,
        number,
      },
    })
  );
}
